// extracted by mini-css-extract-plugin
export default {"container":"CustomLink_container__urbZz","primary":"CustomLink_primary__r+TQk"};